export default __webpack_public_path__ + "static/media/jaronn.a00ee08a.png";